import { auth } from './metas'
const Messenger = () => import('@/pages/Messenger')
const MessengerWelcome = () => import('@/pages/MessengerWelcome')
const MessengerMessage = () => import('@/pages/MessengerMessage')
const MessengerNew = () => import('@/pages/MessengerNew')

export default [
  {
    path: '/messenger',
    component: Messenger,
    meta: auth,
    children: [
      {
        path: '',
        name: 'Messenger',
        component: MessengerWelcome
      },
      {
        path: 'new',
        name: 'MessengerNew',
        component: MessengerNew,
        props: route => ({
          _id: route.query._id,
          name: route.query.name,
          externalId: parseInt(route.query.externalId, 10) || null,
          scope: route.query.scope
        })
      },
      {
        path: ':id',
        name: 'MessengerMessage',
        component: MessengerMessage,
        props: true
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/messenger.route.js